export const ROW_HEIGHT_ESTIMATE = 57;
export const OVERSCAN = 15;
export const LOAD_MORE_ROOT_MARGIN = `${OVERSCAN * ROW_HEIGHT_ESTIMATE}px`;
